import { render, staticRenderFns } from "./ViewCounterContainer.vue?vue&type=template&id=60770814&scoped=true&"
import script from "./ViewCounterContainer.vue?vue&type=script&lang=js&"
export * from "./ViewCounterContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60770814",
  null
  
)

export default component.exports